
import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-2 md:px-4 py-2 md:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center -ml-2 flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/1dec1d861b77ef7dee32dd8f5726e27a/ba451ff0391657a46ef5e851479ca2bc.jpeg" 
              alt="Carthaginian Treasure Logo" 
              className="h-14 md:h-48 w-auto"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            />
          </div>
          
          {/* Mobile Menu - Horizontal */}
          <div className="flex md:hidden items-center gap-1 overflow-x-auto scrollbar-hide">
            <button 
              onClick={() => scrollToSection('heritage')}
              className={`text-[10px] font-medium transition-colors whitespace-nowrap cursor-pointer px-1.5 py-1 ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Heritage
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className={`text-[10px] font-medium transition-colors whitespace-nowrap cursor-pointer px-1.5 py-1 ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Process
            </button>
            <button 
              onClick={() => scrollToSection('benefits')}
              className={`text-[10px] font-medium transition-colors whitespace-nowrap cursor-pointer px-1.5 py-1 ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Benefits
            </button>
            <button 
              onClick={() => scrollToSection('story')}
              className={`text-[10px] font-medium transition-colors whitespace-nowrap cursor-pointer px-1.5 py-1 ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Story
            </button>
            <button 
              onClick={() => scrollToSection('cta')}
              className="bg-amber-500 text-white px-2.5 py-1 rounded-full text-[10px] font-medium hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer shadow-md flex-shrink-0"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Order
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('heritage')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Our Heritage
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Our Process
            </button>
            <button 
              onClick={() => scrollToSection('benefits')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Health Benefits
            </button>
            <button 
              onClick={() => scrollToSection('story')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-600' : 'text-white hover:text-amber-200'
              }`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Our Story
            </button>
            <button 
              onClick={() => scrollToSection('cta')}
              className="bg-amber-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer shadow-md"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Order Now
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
